module.exports = __webpack_public_path__ + "img/tripod.3064f022.jpg";